// vm-view-switch.js (L3, v5.3): "Product | Illustrated heated zones". Sets html[data-vm-view], loads the card
// plates on the first switch (vm-heat-hover.js), fills the live line, remembers the view (sessionStorage).
const R = document.documentElement;
class VmViewSwitch extends HTMLElement {
  connectedCallback() {
    this.onclick = (e) => {
      const b = e.target.closest('[data-view]');
      if (b) this.set(b.dataset.view, 1);
    };
    let v = R.dataset.vmView;
    if (!v) try { v = sessionStorage.getItem('vm-view'); } catch (e) {}
    this.set(v === 'heat' ? v : 'product');
  }
  set(v, save) {
    const heat = v === 'heat';
    const line = document.querySelector('[data-vm-view-line]');
    R.dataset.vmView = v;
    for (const b of this.querySelectorAll('[data-view]')) b.ariaPressed = b.dataset.view === v;
    if (heat) for (const t of document.querySelectorAll('vm-card-tile[data-plate]')) t.load && t.load('plate');
    if (line) line.textContent = heat ? line.dataset.text : '';
    if (save) try { sessionStorage.setItem('vm-view', v); } catch (e) {}
  }
}
customElements.get('vm-view-switch') || customElements.define('vm-view-switch', VmViewSwitch);
